import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  deleteLeaveRoom,
  deleteLeaveRoomSuccess,
  deleteLeaveRoomFailure,
  renameRoom,
  renameRoomSuccess,
  renameRoomFailure,
} from '../actions/room';

export default handleActions<DamzState['damzActions'], any>(
  {
    [`${deleteLeaveRoom}`]: (state, action) => ({
      ...state,
      deleteLeaveRoom: {
        ...state.deleteLeaveRoom,
        isDeleting: true,
      },
    }),
    [`${deleteLeaveRoomSuccess}`]: (state, action) => ({
      ...state,
      deleteLeaveRoom: {
        ...state.deleteLeaveRoom,
        isDeleting: false,
      },
    }),
    [`${deleteLeaveRoomFailure}`]: (state, action) => ({
      ...state,
      deleteLeaveRoom: {
        ...state.deleteLeaveRoom,
        isDeleting: false,
      },
    }),
    [`${renameRoom}`]: (state, action) => ({
      ...state,
      renameRoom: {
        ...state.renameRoom,
        isRenaming: true,
      },
    }),
    [`${renameRoomSuccess}`]: (state, action) => ({
      ...state,
      renameRoom: {
        ...state.renameRoom,
        isRenaming: false,
      },
    }),
    [`${renameRoomFailure}`]: (state, action) => ({
      ...state,
      renameRoom: {
        ...state.renameRoom,
        isRenaming: false,
      },
    }),
  },
  {
    deleteLeaveRoom: {
      isDeleting: false,
    },
    renameRoom: {
      isRenaming: false,
    },
  }
);
